/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-notification-ok_Mesa de trabajo 1': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M15.76 5.52L7.6 13.68a.86.86 0 01-1.19 0L2.25 9.52a.86.86 0 01-.25-.6.82.82 0 01.25-.59.85.85 0 011.19 0L7 11.88l7.56-7.55a.84.84 0 011.2 1.19z"/>'
  }
})
